// extracted by mini-css-extract-plugin
export default {"gallery_container":"Gallery_gallery_container__Bq+YY","gallery_fundacja":"Gallery_gallery_fundacja__f1c8X","gallery_title":"Gallery_gallery_title__D-1-C"};